import styled from "styled-components";
import { TextBold } from "../../../styles/GlobalStyledComponents";

export const UpToDateTitle = styled(TextBold)`
  span {
    text-transform: capitalize;
  }
`;
